import { type InitFlowComponent } from '@capsicum/common';
import { useNCWInitFlow } from '@capsicum/features/nc-onboarding/shared';
import { useMe } from '@capsicum/socios-core';
import { useNonCustodialProviderUserWalletStatus } from '@socios-blk/core';
import { useEffect, useState } from 'react';

import { useNCWInitFlowEnabled } from '../../../../shared/src/hooks/useNCWInitFlowEnabled';

import { NCWExistingUserOnboardingFlow } from './existing-users/NCWExistingUserOnboardingFlow';
import { NCWNewUserOnboardingFlow } from './new-users/NCWNewUserOnboardingFlow';

export const NCWInitFlow: InitFlowComponent = props => {
	const { fallback, isReactive, next } = props;
	const { me } = useMe();
	const [isVisible, setVisibility] = useState<boolean | undefined>(undefined);

	const { isEnabled, isLoading: isNCWInitFlowEnabledLoading } = useNCWInitFlowEnabled({ isReactive });

	const {
		isLoading: isWalletCheckerLoading,
		isNCWalletRegistered,
		isSmartWalletRegistered
	} = useNonCustodialProviderUserWalletStatus({ enabled: isEnabled, retry: 1 });

	useEffect(() => {
		if (isVisible !== undefined || isWalletCheckerLoading || isNCWInitFlowEnabledLoading) return;

		setVisibility(
			isEnabled && (!isNCWalletRegistered || !isSmartWalletRegistered || Boolean(me.metadata?.needsTravelRule))
		);
	}, [
		isVisible,
		isEnabled,
		isNCWalletRegistered,
		isWalletCheckerLoading,
		isSmartWalletRegistered,
		isNCWInitFlowEnabledLoading,
		me.metadata?.needsTravelRule
	]);

	return useNCWInitFlow({
		fallback,
		isReactive,
		isVisible,
		NCWExistingUserOnboardingFlow,
		NCWNewUserOnboardingFlow,
		next
	});
};

NCWInitFlow.keepAlive = true;
